<template>
  <button
    type="button"
    class="bg-background-neutral-secondary flex w-full items-center justify-between gap-3 rounded-2xl p-4 text-left"
    @click="$emit('open')"
  >
    <div class="min-w-0 flex-1">
      <p class="text-text-neutral-primary truncate text-lg font-semibold">
        {{ title }}
      </p>
      <div class="mt-3 flex items-center gap-2">
        <span
          v-if="savedSearchesCount > 0"
          class="text-text-neutral-secondary bg-background-neutral-primary inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs"
        >
          <SearchIcon class="text-text-info-primary size-3.5 shrink-0" />
          {{ $t('favoritesPage.searches', { n: savedSearchesCount }) }}
        </span>
        <span
          v-if="savedTicketsCount > 0"
          class="text-text-neutral-secondary bg-background-neutral-primary inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs"
        >
          <FavoriteActiveIcon
            class="text-text-negative-primary size-3.5 shrink-0"
          />
          {{ $t('favoritesPage.tickets', { n: savedTicketsCount }) }}
        </span>
      </div>
    </div>
    <ChevronIcon
      class="text-text-neutral-quaternary size-5 shrink-0 -rotate-90"
    />
  </button>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import type { Dict } from '@aviata/platform-types';
  import type { appLocale } from 'shared';

  import { routeTitleFromEndpoints } from '@/features/favorites';

  type Locale = appLocale.config.Locale;

  import ChevronIcon from '@/assets/images/chevron-arrow-20x20.svg?component';
  import FavoriteActiveIcon from '@/assets/images/favorite-active-icon.svg?component';
  import SearchIcon from '@/assets/images/search-icon.svg?component';

  const props = defineProps<{
    dep: string;
    arr: string;
    savedSearchesCount: number;
    savedTicketsCount: number;
    dict?: Dict.Entity;
  }>();

  defineEmits<{
    open: [];
  }>();

  const { locale } = useI18n();

  const title = computed(() =>
    routeTitleFromEndpoints(
      props.dep,
      props.arr,
      props.dict,
      locale.value as Locale,
    ),
  );
</script>
